// import { MenuDefaultService } from './../../../../../../../core/shared/services/menu.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NavController, ModalController, ToastController } from '@ionic/angular';
import { UiBsMyDataService } from '@wlp/ui-bs-my-data';
import { RegisterKeyService, ClaimsKeysPixService } from '@wlp/ui-bs-pix';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { UICMenuAppService } from '@wlp/ui-c-menu-app';
import { of, Subject } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { ModalPixManagementKeyComponent } from '../../../../modals/modal-pix-management-key/modal-pix-management-key.component';
import { CodeValidationPage } from '../portability-keys/code-validation/code-validation.page';
import { ModalService } from 'src/app/core/shared/services/modal.service';

import { UserInfoProfile, UserInfoService } from '@wlp/ui-bs-login';

@Component({
  selector: 'app-pix-register-key',
  templateUrl: './register-key-pix.page.html',
  styleUrls: ['./register-key-pix.page.scss', '../skeleton-pix-base/skeleton-pix-base.page.scss'],
})
export class PixRegisterKeyPage implements OnInit, OnDestroy {
  private keyPix: string;
  private keyTypePix: string;
  public userInfo: any;
  public cpfMasked: string;
  public backgroundImage: any;

  public isCpfCnpf: boolean = false;
  public isPhone: boolean;
  public isEmail: boolean;
  public isAddress: boolean;

  public textTypeKey: string;
  public mask: string;
  public indexController: any;

  public listObjectCards: object;
  public formRegisterKey: FormGroup;
  public errorFormMessages: any;
  public cpfCnpj: any;
  public email: any;
  public phone: any;
  public virtualAdrress: any;
  public userProfile: any;
  dataForm: unknown;
  wlName: any;

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;
  dataDefault: {};
  validationKey: any;

  
  private destroy$: Subject<null> = new Subject();

  constructor(
    protected authService: UserInfoService,
    private navCtrl: NavController,
    private service: RegisterKeyService,
    private loadingService: LoadingService,
    private modalController: ModalController,
    private layoutConfigService: LayoutConfigService,
    private router: Router,
    private claimService: ClaimsKeysPixService,
    private translate: UiBsTranslateService,
    private myDataService: UiBsMyDataService,
    private toastController: ToastController,
    // private menuDefaultService: MenuDefaultService,
    private modalService: ModalService
  ) {
    // this.menuDefaultService.setStatus(true);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

    this.loadUser();

    this.backgroundImage = this.layoutConfigService.getConfig('wlTheme.header.background.image');
    this.wlName = this.layoutConfigService.getConfig('wlTheme.wlName');

    this.errorFormMessages = this.service.getFormMessageError();
    this.formRegisterKey = this.service.getFormRegisterKey();

    this.prepareCardsKeys();
  }

  loadUser() {
    this.loadingService.show()

    this.authService.getInfoProfile().then((res) => {
      this.userProfile = res;
      this.getListKey();
      this.myDataService
        .getPersonalData(res.uuidAccount)
        .pipe(
          tap((data) => {
            this.dataDefault = {
              documentDefault: this.formatCnpjCpf(data.document),
              emailDefault: this.userProfile.email,
            };
          })
        )
        .subscribe();
    });

    this.loadingService.hide()
  }

  goBack() {
    this.navCtrl.navigateRoot('/app/pix/manage-keys');
  }

  async continue() {
    this.keyTypePix = this.formRegisterKey.get('keyType').value;
    this.keyPix = '';
    switch (this.keyTypePix) {
      case 'CNPJ':
        this.createkey();
        break;
      case 'CPF':
        this.createkey();
        break;
      case 'PHONE':
        this.keyPix = `+55${this.formRegisterKey.get('keyTextValue').value.replace(/<!^\s*\)\+|[^\d+]+/g, '')}`;
        break;
      case 'EMAIL':
        this.keyPix = this.formRegisterKey.get('keyTextValue').value;
        break;
      case 'EVP':
        this.keyPix = "";
        this.createkey();
        break;
      default:
        this.keyPix = this.formRegisterKey.get('keyTextValue').value;
        break;
    }

    if (this.keyTypePix === 'PHONE' || this.keyTypePix === 'EMAIL') {
      this.presentModalValidation();
    }
  }

  public getImageByTag(tag: string) {
    let item: any = this.layoutConfigService.getImagesPages(tag);
    if (item) return item.path;
    return '';
  }

  formIsValid() {
    return this.checkingKeyPixForm(this.formRegisterKey);
  }

  private checkingKeyPixForm(form: FormGroup): boolean {
    const typeKey = form.get('keyType').value;
    const inputValue = form.get('keyTextValue').value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if(typeKey === 'EVP') return true;
    else if(typeKey === 'CPF' && inputValue.length === 14) return true;
    else if(typeKey === 'CNPJ' && inputValue.length === 18) return true;
    else if(typeKey === 'EMAIL' && emailRegex.test(inputValue)) return true;
    else if(typeKey === 'PHONE' && inputValue.length === 15) return true;
    else return false;
  }

  async modalClaimKey(
    title: string,
    subtitle: string,
    dismissText: string,
    confirmText: string,
    imageModal: boolean,
    imageTag: string,
    doubleButton: boolean,
    clearButton: boolean,
    params: Object,
    classModal?
  ) {
    const modal = await this.modalController.create({
      component: ModalPixManagementKeyComponent,
      cssClass: classModal ? classModal : 'modal-pix-management-key-class-claim',
      componentProps: {
        title,
        subtitle,
        dismissText,
        confirmText,
        imageModal,
        imageTag,
        doubleButton,
        clearButton,
        params,
      },
      backdropDismiss: false,
    });
    await modal.present();
    return await modal.onWillDismiss();
  }

  verifyTypeKey(type: any) {
    switch (type) {
      case 'CPF': {
        return 'CPF/CNPJ';
      }
      case 'PHONE': {
        return 'Telefone';
      }
      case 'EMAIL': {
        return 'Email';
      }
    }
  }

  claimKey() {
    this.modalClaimKey(
      'PIX.PIX_REGISTER_KEY.MESSAGES.TITLE_REGISTERED_KEY_OTHER_PERSON',
      'PIX.PIX_REGISTER_KEY.MESSAGES.MESSAGE_REGISTERED_KEY_OTHER_PERSON',
      'PIX.PIX_REGISTER_KEY.MESSAGES.MESSAGE_CLAIM_KEY',
      'PIX.PIX_REGISTER_KEY.MESSAGES.MESSAGE_REGISTRY_OTHER_KEY',
      false,
      '',
      false,
      false,
      null,
      'modal-pix-management-key-class-medium'
    ).then((res) => {
      console.log(res);
      /* Reivindicar chave */
      if (res.data.dismissed) {
        this.router.navigate(['app/pix/claim-keys'], {
          state: { claimType: 'OWNERSHIP', key: this.keyPix, type: this.keyTypePix },
        });
      }
    });
  }

  portabilityModal() {
    this.modalClaimKey(
      'PIX.PIX_REGISTER_KEY.MESSAGES.TITLE_REGISTERED_KEY',
      'PIX.PIX_REGISTER_KEY.MESSAGES.MESSAGE_REGISTERED_KEY',
      'PIX.PIX_REGISTER_KEY.MESSAGES.MESSAGE_PORTABILITY',
      'PIX.PIX_REGISTER_KEY.MESSAGES.MESSAGE_REGISTRY_OTHER_KEY',
      false,
      '',
      false,
      false,
      null,
      'modal-pix-management-key-class-medium'
    ).then((res) => {
      /* Portabilidade chave */
      if (res.data.dismissed) {
        this.creatPortabilityCPFCNPJ();
      }
    });
  }

  creatPortabilityCPFCNPJ() {
    this.loadingService.show();
    const claimRequest = {
      uuidAccountPayment: this.userProfile.uuidAccount,
      keyType: this.keyTypePix,
      key: this.keyPix,
      claimType: 'PORTABILITY',
    };

    const params = {
      key: this.keyPix,
      wlName: this.wlName,
    };

    this.claimService.createConfirm(claimRequest).subscribe((res) => {
      if (res.status === 'CREATED') {
        this.loadingService.hide();
        this.modalClaimKey(
          'PIX.PIX_REGISTER_KEY.MESSAGES.TITLE_PORTABILITY_REQUESTED',
          'PIX.PIX_REGISTER_KEY.MESSAGES.MESSAGE_PORTABILITY_REQUESTED',
          null,
          'PIX.PIX_REGISTER_KEY.BUTTONS.CONTINUE_BUTTON',
          false,
          null,
          false,
          false,
          params,
          'modal-pix-management-key-class-medium'
        ).then((res) => {
          if (res) {
            this.router.navigate(['/app/pix']);
          }
        });
      } else {
        this.loadingService.hide();
        this.showNotification('warning-circle', 'Atenção!', res.message);
      }
    });
  }

  formatCnpjCpf(value) {
    const cnpjCpf = value.replace(/\D/g, '');
    if (cnpjCpf.length === 11) {
      return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    }
    return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
  }

  prepareCardsKeys() {
    this.cpfCnpj = this.layoutConfigService.getImagesPages('cpf-cnpj-pix');
    this.email = this.layoutConfigService.getImagesPages('email-pix');
    this.phone = this.layoutConfigService.getImagesPages('phone-pix');
    this.virtualAdrress = this.layoutConfigService.getImagesPages('virtual-address-pix');

    this.listObjectCards = [
      {
        path: this.cpfCnpj.path,
        type: 'cpfCnpj',
        cardLabel: 'PIX.PIX_REGISTER_KEY.CARDS_LABELS.RG_CNPJ',
        inputLabel: 'PIX.PIX_REGISTER_KEY.INPUT_LABELS.RG_CNPJ',
        placeholder: 'PIX.PIX_REGISTER_KEY.PLACEHOLDER_LABELS.RG_CNPJ',
        disabled: false,
      },
      {
        path: this.phone.path,
        type: 'phone',
        cardLabel: 'PIX.PIX_REGISTER_KEY.CARDS_LABELS.PHONE',
        inputLabel: 'PIX.PIX_REGISTER_KEY.INPUT_LABELS.PHONE',
        placeholder: 'PIX.PIX_REGISTER_KEY.PLACEHOLDER_LABELS.PHONE',
        disabled: false,
      },
      {
        path: this.email.path,
        type: 'email',
        cardLabel: 'PIX.PIX_REGISTER_KEY.CARDS_LABELS.EMAIL',
        inputLabel: 'PIX.PIX_REGISTER_KEY.INPUT_LABELS.EMAIL',
        placeholder: 'PIX.PIX_REGISTER_KEY.PLACEHOLDER_LABELS.EMAIL',
        disabled: false,
      },
      {
        path: this.virtualAdrress.path,
        type: 'virtualAdrress',
        cardLabel: 'PIX.PIX_REGISTER_KEY.CARDS_LABELS.VIRTUAL_ADDRESS',
        inputLabel: 'PIX.PIX_REGISTER_KEY.INPUT_LABELS.VIRTUAL_ADDRESS',
        placeholder: 'PIX.PIX_REGISTER_KEY.PLACEHOLDER_LABELS.VIRTUAL_ADDRESS',
        disabled: false,
      },
    ];
  }

  async presentModalValidation() {
    const modalCodevalidation = await this.modalController.create({
      component: CodeValidationPage,
      componentProps: {
        key: this.keyPix,
        type: this.keyTypePix,
      },
    });
    modalCodevalidation.present();

    modalCodevalidation.onDidDismiss().then((data) => {
      if (data.data) {
        this.createkey();
      }
    });
  }

  createkey() {
    this.loadingService.show();
    this.service
      .registerKey(this.formRegisterKey.get('keyType').value, this.keyPix)
      .pipe(
        tap((res) => {
          this.loadingService.hide();
          switch (res.status) {
            case 'CREATED': {
              this.loadingService.hide();
              this.showNotification('success', 'Sucesso!', res.message);
              this.navCtrl.navigateRoot(['app/pix/manage-keys']);
              return;
            }
            case 'HAS_KEY_OTHER_BANK': {
              this.loadingService.hide();
              this.portabilityModal();
              return;
            }
            case 'HAS_KEY_OTHER_USER': {
              this.loadingService.hide();
              this.claimKey();
              return;
            }
            case 'NOT_CREATED': {
              this.loadingService.hide();
              this.showNotification('warning-circle', 'Atenção!', res.message);
              return;
            }
          }
        }),
        catchError((_) => {
          this.loadingService.hide();
          return of(null);
        })
      )
      .subscribe();
  }

  getListKey() {
    try {
      this.service.getAllKey(this.userProfile.uuidAccount).subscribe((res) => {
        const exits = res.data.find((elem) => {
          return elem.typeKey === 'CPF' || elem.typeKey === 'CNPJ';
        });

        if (exits) {
          this.listObjectCards[0].disabled = true;
        }
      });
    } catch (error) {}
  }

  async emitToastDocumentClick(ev) {
    this.creatToast('Você já possui essa chave pix cadastrada!');
  }

  async creatToast(message) {
    let toast = await this.toastController.create({
      message,
      duration: 5000,
      position: 'top',
      buttons: [
        {
          text: 'Fechar',
          role: 'cancel',
          handler: () => {},
        },
      ],
    });

    toast.present();
  }

  private async showNotification(status: string, message: string, description: string) {
    await this.modalService.notificationAlert({
      status: status,
      message: message,
      confirmation: false,
      description: description,
      confirmBtn: 'Ok',
      translate: true,
      backdropDismiss: false,
    });
  }
}
